import React, { useEffect, useRef, useState } from "react";
import "../Forgot.scss";

import { FaChevronLeft } from "react-icons/fa";

import CustomButton from "../../../components/CustomButton/CustomButton";
import { useForm } from "react-hook-form";
import { Link, useLocation, useNavigate } from "react-router-dom";
import ROUTES from "../../../constants/routes";
import OTPInputField from "../../../components/UserFormComponents/OTPInputField/OTPInputField";
import {
  resendUserOtp,
  verifyForgotPasswordOtp,
  verifyUserOtp,
} from "../../../api/auth";
import { toast } from "react-toastify";
import DesktopLoginContents from "../../../components/DesktopLoginContents/DesktopLoginContents";
import Captcha from "../../../components/Captcha/Captcha";
import { Capacitor } from "@capacitor/core";
import { useSelector } from "react-redux";

const VerifyOTP = () => {
  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors },
  } = useForm();

  const navigate = useNavigate();
  const location = useLocation();
  const email = location.state?.email || null;
  const phone = location.state?.phone || null;
  const userVerify = location.state?.userVerify || false;

  const resendTimer = location.state?.resendTimer || 60;

  const [submitting, setSubmitting] = useState(false);
  const [timer, setTimer] = useState(0);

  const reRef = useRef();

  const user = useSelector((state) => state.userReducer.value);

  useEffect(() => {
    if (user.token) {
      navigate(ROUTES.home.path);
    }
  }, []);

  useEffect(() => {
    let interval;

    if (timer > 0) {
      interval = setInterval(() => {
        setTimer((prevTimer) => prevTimer - 1);
      }, 1000);
    } else {
      setTimer(0);
      clearInterval(interval);
    }

    return () => clearInterval(interval);
  }, [timer]);

  useEffect(() => {
    if (!email) {
      navigate(ROUTES.login.path);
    }
  }, [email, phone]);

  useEffect(() => {
    setTimer(resendTimer);
  }, [resendTimer]);

  const handleVerifyOTP = async (data) => {
    setSubmitting(true);
    let captchaToken = "";
    let source = "";
    if (Capacitor.isNativePlatform()) {
      source = "mobile";
    } else {
      captchaToken = await reRef.current.executeAsync();
    }
    if (userVerify) {
      const credentials = {
        email: email,
        otp: data?.otp ? Number(data?.otp) : null,
        captchaToken: captchaToken,
        source: source,
      };
      verifyUserOtp(credentials)
        .then((res) => {
          if (res.data?.success) {
            toast.dismiss(); toast.success(res.data.message);
            navigate(ROUTES.login.path);
          } else {
            toast.dismiss(); toast.error(res.data.message);
          }
        })
        .catch((err) => {
          if (err?.response?.data?.message) {
            toast.dismiss(); toast.error(err?.response?.data?.message);
          } else {
            toast.dismiss(); toast.error("OTP verification failed!");
          }
        })
        .finally(() => {
          setSubmitting(false);
        });
    } else {
      const credentials = {
        email: email,
        otp: data?.otp ? Number(data?.otp) : null,
        captchaToken: captchaToken,
        source: source,
      };
      verifyForgotPasswordOtp(credentials)
        .then((res) => {
          if (res.data?.message) {
            toast.dismiss(); toast.success(res.data.message);
          } else {
            toast.dismiss(); toast.success("OTP verified successfully.");
          }
          navigate(ROUTES.resetPassword.path, {
            state: {
              credentials: {
                email: credentials.email,
                otp: credentials.otp,
              },
            },
          });
        })
        .catch((err) => {
          if (err?.response?.data?.message) {
            toast.dismiss(); toast.error(err?.response?.data?.message);
          } else {
            toast.dismiss(); toast.error("OTP verification failed!");
          }
        })
        .finally(() => {
          setSubmitting(false);
        });
    }
  };

  const handleResendOTP = async () => {
    if (timer === 0 && email && !submitting) {
      setSubmitting(true);
      let captchaToken = "";
      let source = "";
      if (Capacitor.isNativePlatform()) {
        source = "mobile";
      } else {
        captchaToken = await reRef.current.executeAsync();
      }
      const credentials = {
        email: email,
        isUserVerify: userVerify ? true : false,
        captchaToken: captchaToken,
        source: source,
      };

      resendUserOtp(credentials)
        .then((res) => {
          if (res.data?.message) {
            toast.dismiss(); toast.success(res.data?.message);
          } else {
            toast.dismiss(); toast.success("OTP is sent to your email address.");
          }
          if (res.data?.resend_timer) {
            setTimer(Number(res.data?.resend_timer));
          } else {
            setTimer(60);
          }
        })
        .catch((err) => {
          if (err?.response?.data?.message) {
            toast.dismiss(); toast.error(err?.response?.data?.message);
          } else {
            toast.dismiss(); toast.error("OTP resend failed! Please try again later.");
          }
          if (err?.response?.data?.resend_timer) {
            setTimer(Number(err?.response?.data?.resend_timer));
          } else {
            setTimer(60);
          }
        })
        .finally(() => {
          setSubmitting(false);
        });
    }
  };

  const [reset, setReset] = useState(false);

  const clearOTP = () => {
    setReset((pre) => !pre);
  };
  return (
    <>
      <Captcha reRef={reRef} />
      <div className="initial-page-contents">
        <div className="forgot-page">
          <form
            onSubmit={handleSubmit(handleVerifyOTP)}
            className="form-container"
          >
            <div className="upper">
              <Link
                to={userVerify ? ROUTES.login.path : ROUTES.forgotPassword.path}
                className="go-back"
              >
                <FaChevronLeft />
              </Link>
              <div className="heading">
                <p className="title">
                  Enter <br />
                  <span>Verification Code</span>
                </p>
                <p className="message">
                  We have sent the code to <span>{email}</span>
                </p>
              </div>

              <div className="inputs">
                <OTPInputField
                  numberOfFields={5}
                  setValue={setValue}
                  name={"otp"}
                  required={true}
                  register={register}
                  inputErrors={errors}
                  reset={reset}
                />
                <p className="clear-text" onClick={clearOTP}>
                  Clear
                </p>
              </div>
            </div>

            <div className="lower">
              <CustomButton
                name={"Verify Now"}
                type={"submit"}
                color={"white reverse"}
                bigButton={true}
                disabled={submitting}
                handleSubmit={() => {}}
                loader={submitting}
              />

              <p className="resend">
                Didn't you Receive any code?{" "}
                <span
                  className={timer > 0 ? "danger" : ""}
                  onClick={handleResendOTP}
                >
                  {timer > 0
                    ? `RESEND CODE in ${timer} seconds`
                    : "RESEND CODE"}
                </span>
              </p>

              <p className="company-tag">
                &copy; Daikofin <span></span>
                <Link to={ROUTES.contactDUS.path}>Contact</Link>
                <span></span>
                <a href={"https://daikoapp.com/index.php/73-2/"} target="blank">
                  Privacy & terms
                </a>
              </p>
            </div>
          </form>
        </div>
        <DesktopLoginContents />
      </div>
    </>
  );
};

export default VerifyOTP;
